function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocPlaygroundFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67 10.93c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-1 3c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm1.88-11.59c-.45-.43-1.16-.45-1.63-.04L2.41 8.06c-.83.73-.31 2.1.8 2.1h.47v19.77h2v-10h8v2H5.67v2h8v2h-8v2h8v2h2v-8.72l8.37 8.37c.23.22.53.35.85.35h3.58c.66 0 1.2-.54 1.2-1.2v-3.6c0-.66-.54-1.2-1.2-1.2h-1.86l-7.53-8.19v-2.61c0-.66-.54-1.2-1.2-1.2h-2.21v-1.77c1.08 0 1.61-1.31.83-2.06l-5.95-5.76zM5.31 8.16l4.37-3.87 4.01 3.87H5.31zm8.36 9.77h-8v-7.77h8v7.77zm2-4v4.45l9.55 9.55h2.45v-2h-1.41c-.34 0-.66-.14-.88-.39l-7.97-8.68c-.2-.22-.32-.51-.32-.81v-2.12h-1.42z",
    fill: props.color
  }));
}

export default SvgIconPocPlaygroundFilled;